export default "__VITE_ASSET___wQsmUZW__"